// React Imports
import * as React from "react";
import {useState, useEffect, createContext} from "react";
import 'react-format-currency';
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import {
    Avatar,
    Stack,
    Tooltip
} from "@mui/material";
import {blue, brown, deepOrange, deepPurple, teal} from "@mui/material/colors";
import {DataGridPro, GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import ReorderIcon from "@mui/icons-material/Reorder";
import {getContractSectionCDP} from "../../../../ContractDataPoint/ContractDataPointClient";
import {changeContractDataPoint} from "../../../../ContractDataPoint/contractDataPointSlice";
import DynamicCdpvValueField from "../../../../CommonComponents/DynamicCdpvValueField";
import Button from "@mui/material/Button";
import {patchCdpvHelperValues} from "../../../../ContractDataPointValue/ContractDataPointValueClient";
import {changeContractDrilldown} from "../../../contractDrilldownSlice";
import {getHelperData, updateNameByLabel} from "../../../../ContractSection/ContractSectionClient";
import {changeContractSection} from "../../../../ContractSection/contractSectionSlice";
import {changeCrudSnackbar} from "../../../../CommonComponents/crudSnackbarSlice";

// App Imports

// main function
export default function DynamicHelper(props) {


    // ****************** BEGIN STATES ****************************

    const [drilldownCDP, setDrilldownCDP] = useState([]);
    const [allCDPs, setAllCDPs] = useState([]);
    const [filteredCDP, setFilteredCDP] = useState([]);
    const [drilldownCDPV, setDrilldownCDPV] = useState(null);
    const [showCdpvGrid, setShowCdpvGrid] = useState(false);
    const [showCdpvfGrid, setShowCdpvfGrid] = useState(false);
    const [cdpInfoOpen, setCdpInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const expandedCdpId  = useSelector((state) => state.contractDrilldownSlcExpandCS.value.cdpId);
    const selectorCDPId = useSelector((state) => state.contractDataPointValueSlc.value.contractDataPointId);
    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);
    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    const selectorCdpGridRefresh = useSelector((state) => state.contractSlc.value.cdpGridRefresh);
    const selectorContractSectionName = useSelector((state) => state.contractSectionSlc.value.name);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const hideActions = localStorage.getItem('hideActions') === "true";


    // ****************** BEGIN FETCH ****************************
    //
    // const fetchInputCdp = () =>
    //     getContractSectionCDP(selectorContractSectionId)

    //         .then(data => {
    //             console.log(data);
    //
    //             setFilteredCDP(
    //                 data.filter(item => item.mockOrigin === "Input")
    //             );
    //         })
    //         .then(
    //             getHelperData(selectorContractSectionId))

    //     .then(data => {
    //         console.log("helper data");
    //         console.log(data);
    //
    //     })
    // ;


    //
    // const fetchInputCdp = async () => {
    //     // const cdpRes = await getContractSectionCDP(selectorContractSectionId);
    //     // const cdpData = cdpRes.data;
    //     //
    //     // console.log(cdpData);
    //     //
    //     // setFilteredCDP(
    //     //     cdpData.filter(item => item.mockOrigin === "Input")
    //     // );
    //     console.log("fetching helper data");
    //     const helperRes = await getHelperData(selectorContractSectionId);
    //     const helperData = helperRes.data;
    //
    //     console.log("helper data");
    //     console.log(helperData);
    //     setFilteredCDP(helperData);
    // };
    //
    const fetchInputCdp = async () => {
        if (!selectorContractSectionId) return;

        console.log("fetching helper data");

        const helperData = await getHelperData(selectorContractSectionId);

        console.log("helper data");
        console.log(helperData);

        setFilteredCDP(helperData);
    };
    //
    //
    // const fetchInputCdp = async () => {
    //     if (!selectorContractSectionId) return;
    //
    //     console.log("fetching helper data");
    //
    //     try {
    //         const helperData = await getHelperData(selectorContractSectionId);
    //
    //         console.log("helper data");
    //         console.log(helperData);
    //
    //         setFilteredCDP(helperData);
    //     } finally {
    //         dispatchData(
    //             changeContractDataPoint({ cdpGridRefresh: true })
    //         );
    //
    //         dispatchData(
    //             changeContractSection({ csGridRefresh: true })
    //         );
    //     }
    // };

    // const fetchInputCdp = async () => {
    //     if (!selectorContractSectionId) return;
    //
    //     console.log("fetching helper data");
    //
    //     try {
    //         const helperData = await getHelperData(selectorContractSectionId);
    //
    //         console.log("helper data");
    //         console.log(helperData);
    //
    //         setFilteredCDP(helperData);
    //     } catch (error) {
    //         console.error("Error fetching helper data:", error);
    //     } finally {
    //         dispatchData(changeContractDataPoint({ cdpGridRefresh: true }));
    //         dispatchData(changeContractSection({ csGridRefresh: true }));
    //     }
    // };

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("My CDP is loading so far...");
        fetchInputCdp();
    }, [useSelector((state) => state.contractSectionSlc.value.id)]);


    // useEffect(() => {
    //     if (selectorCdpGridRefresh===false) return;
    //     fetchInputCdp();
    //     dispatchData(changeContractDataPoint({cdpGridRefresh: false}));
    // }, [useSelector((state) => state.contractDataPointSlc.value.cdpGridRefresh)===true]);


    useEffect(() => {
            console.log("drilldownCDPV length outside");
            if(drilldownCDPV !== null) {
                console.log("drilldownCDPV length inside");
                console.log(drilldownCDPV.length);
            }
        },
        [useSelector((state)=> state.contractDataPointSlc.value.id)]
    );

    // ******************** END USE EFFECTS *******************


    const handleExit = () => {
        dispatchData(changeContractDrilldown({dynamicHelperState: false}));
    }

    //
    // const handleSubmitValues = () => {
    //     const updates = filteredCDP
    //         .filter(row => row.cdpvId != null)
    //         .map(row => ({
    //             cdpvId: row.cdpvId,
    //             cdpvValue: row.cdpvValue ?? null
    //         }));
    //
    //     console.log("helper value updates", updates);
    //
    //     patchCdpvHelperValues(updates)
    //         .then(res => {
    //             console.log("Updated values:", res);
    //             console.log("trying to update cs name by label:", updates.map(row => row.cdpvId));
    //             dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Data Submitted"}));
    //      return updateNameByLabel(updates.map(row => row.cdpvId));
    //         })
    //         .catch(err => {
    //             console.error("Failed to update values", err);
    //             dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Submit Failed"}));
    //         })
    //         .finally(() => {
    //             dispatchData(changeContractDataPoint({cdpGridRefresh: true}))
    //             dispatchData(changeContractSection({csGridRefresh: true}));
    //         });
    // };

    const handleSubmitValues = async () => {
        const updates = filteredCDP
            .filter(row => row.cdpvId != null)
            .map(row => ({
                cdpvId: row.cdpvId,
                cdpvValue: row.cdpvValue ?? null
            }));

        console.log("helper value updates", updates);

        try {
            const res = await patchCdpvHelperValues(updates);

            console.log("Updated values:", res);
            console.log(
                "trying to update cs name by label:",
                updates.map(row => row.cdpvId)
            );

            await updateNameByLabel(
                updates.map(row => row.cdpvId)
            );

            // Re-fetch THIS helper first
            await fetchInputCdp();

            // Now tell the OTHER grids to refresh
            dispatchData(
                changeContractDataPoint({ cdpGridRefresh: true })
            );

            dispatchData(
                changeContractSection({ csGridRefresh: true })
            );

            dispatchData(
                changeCrudSnackbar({
                    crudOpen: true,
                    crudSeverity: "success",
                    crudMessage: "Data Submitted"
                })
            );

        } catch (err) {
            console.error("Failed to update values", err);

            dispatchData(
                changeCrudSnackbar({
                    crudOpen: true,
                    crudSeverity: "error",
                    crudMessage: "Submit Failed"
                })
            );
        }
    };

        // const handleSubmitValues = async () => {
        //     const updates = filteredCDP
        //         .filter(row => row.cdpvId != null)
        //         .map(row => ({
        //             cdpvId: row.cdpvId,
        //             cdpvValue: row.cdpvValue ?? null
        //         }));
        //
        //     console.log("helper value updates", updates);
        //
        //     try {
        //         const updateRes = await patchCdpvHelperValues(updates);
        //         console.log("Updated values:", updateRes.data);
        //
        //         console.log("fetching helper data");
        //         const helperRes = await getHelperData(selectorContractSectionId);
        //
        //         setFilteredCDP(helperRes.data);
        //
        //         dispatchData(changeContractDataPoint({ cdpGridRefresh: true }));
        //         dispatchData(changeContractSection({ csGridRefresh: true }));
        //     } catch (err) {
        //         console.error("Failed to update values", err);
        //     }
        // };


    const handleValueChange = (id, newValue) => {

        setFilteredCDP(prev =>
            prev.map(row =>
                row.id === id
                    ? {
                        ...row,
                        cdpvValue: newValue
                    }
                    : row
            )
        );
    };
    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

 //    const columns = fetchInputCdp => [
 //
 //
 //        {
 //            field: 'id',
 //            headerName: 'ID',
 //            description: '',
 //            sortable: true,
 //            width: 60,
 //            hide: true,
 //        },
 //        {
 //            field: 'contractSectionId',
 //            headerName: 'cs',
 //            description: '',
 //            sortable: true,
 //            width: 30,
 //            hide: true,
 //        },
 //        {
 //            field: 'dataType',
 //            headerName: 'Data Type',
 //            description: '',
 //            sortable: true,
 //            width: 50,
 //            hide: true,
 //        },
 //
 //        {
 //            field: 'dataPointName',
 //            headerName: 'Name',
 //            description: '',
 //            sortable: true,
 //            width: 200,
 //            hide: false,
 //        },
 //
 //        {
 //            field: 'mockValue',
 //            headerName: 'Value',
 //            width: 200,
 //            editable: true,
 //            renderEditCell: (params) => (
 //                <DynamicCdpvValueField
 // selectorContext={null}
 // selectorLabel={ null}
 //    selectorDataType={params.row.dataType}
 //    selectorValue={params.row.mockValue ?? ''}
 //    selectorDataPointId={params.row.dataPointId}
 //                    onChange={(newValue) => {
 //                        params.api.setEditCellValue({
 //                            id: params.id,
 //                            field: 'mockValue',
 //                            value: newValue
 //                        });
 //                    }}
 //                />
 //            )
 //        }
 //
 //    ]

    // *************** END COLUMNS *******************************





    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height: '100%' , width: '100%' }}>
            <h2>{selectorContractSectionName}</h2>
            <Stack direction="row" spacing={2} alignItems="center"
                   // justifyContent="space-between"
                mb={2}
            >
            <Button
                autoFocus
                onClick={handleSubmitValues}>
                Submit
            </Button>
                <Button onClick={handleExit}>
                    Exit Helper
                </Button>
            </Stack>
            <Box sx={{ width: '100%' }}>
                {filteredCDP.map(row => (
                    <Box
                        key={row.cdpvId}
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '300px 1fr',
                            gap: 2,
                            alignItems: 'center',
                            mb: 1
                        }}
                    >
                        <Stack direction="row" spacing={1} alignItems="center">
                        <Typography fontWeight="bold">
                            {row.dataPointName}
                        </Typography>
                        {/*<Button>Multi</Button>*/}
                        </Stack>

                        <DynamicCdpvValueField
                            selectorContext={null}
                            selectorLabel={ null}
                               selectorDataType={row.dataType}
                               selectorValue={row.cdpvValue ?? ''}
                               selectorDataPointId={row.dataPointId}

                            row={row}
                            // value={row.mockValue}
                            onChange={(newValue) => {
                                setFilteredCDP(prev =>
                                    prev.map(item =>
                                        item.cdpvId === row.cdpvId
                                            ? { ...item, cdpvValue: newValue }
                                            : item
                                    )
                                );
                            }}
                            // onChange={(newValue) =>
                            //     handleValueChange(row.id, newValue)
                            // }
                        />
                    </Box>
                ))}
            </Box>
            {/*<DataGridPro*/}
            {/*    style={{ height: '100%' , width: '100%' }}*/}
            {/*    aria-label={"ContractDataPoints2"}*/}
            {/*    rows={filteredCDP}*/}
            {/*    sx={{*/}
            {/*        '& .MuiDataGrid-detailPanel': {*/}
            {/*            backgroundColor: deepOrange[100],*/}
            {/*        },*/}
            {/*    }}*/}
            {/*    onRowClick = {(filteredCDP)=>handleClickedRow(filteredCDP.row)}*/}
            {/*    rowThreshold={0}*/}
            {/*    disableDensitySelector={true}*/}
            {/*    disableColumnSelector={true}*/}
            {/*    columns={columns(fetchInputCdp)}*/}
            {/*    density={"compact"}*/}
            {/*    pageSize={50}*/}
            {/*    rowsPerPageOptions={[50]}*/}
            {/*    hideFooter = {true}*/}
            {/*    initialState={{*/}
            {/*        sorting: {*/}
            {/*            sortModel: [{ field: 'ordinalNumber', sort: 'asc' }],*/}
            {/*        },*/}
            {/*    }}*/}
            {/*/>*/}
        </div>
    );

    // ****************** END RETURN ****************************


}



